// extracted by mini-css-extract-plugin
module.exports = {"container":"e_vB","up":"e_wB","down":"e_xB","percent":"e_yB","percentVal":"e_zB","title":"e_AB","tags":"e_BB","textBadge":"e_CB"};